import Link from "next/link";
import React, { useContext, useState, useTransition } from "react";
import helper from "../../lib/helper";
import brandModel from "../../models/brands.model";
import useSWR from "swr";
import Pagination from "../../components/Pagination";
import Heading from "../../components/Heading";
import Table from "../../components/Table";
import { useRouter } from "next/router";
import config from "../../lib/config";
import { Button } from "react-bootstrap";
import moment from "moment/moment";

const Page = function () {
    const [showLoader, setShowLoader] = useState(false);

    const router = useRouter();
    const queryParams = router.query;
    const { data: brandData, mutate: reloadbrandData, isLoading } = useSWR(
        queryParams || null,
        () => brandModel.list(queryParams),
        config.swrConfig
    );

    const columns = [
        {
            Header: "Name",
            accessor: "name",
            className: "col"
        },
        
        {
            Header: "Date",
            id: "created_at",
            Cell: ({ row }) => (
                <>
                    <div>
                    {helper.date.format(row.original.created_at)}
                    </div>
                </>
            )
            },
         {
            className: "col-auto text-end",
            Header: "Actions",
            id: "action",
            Cell: ({ row }) => (
                <>
                    <div className="btn-group btn-group-sm">
                        <Link
                            className="btn btn-primary"
                            href={`/brands/${row.original.id}`}
                        >
                            <i className="bi bi-eye"></i>
                        </Link>
                        <Link
                            className="btn btn-warning"
                            href={`/brands/${row.original.id}/edit`}
                        >
                            <i className="bi bi-pencil-square"></i>
                        </Link>
                        <button
                            className="btn btn-danger"
                            onClick={() => confirmDelete(row.original.id, row.original.name)}
                        >
                            <i className="bi bi-trash"></i>
                        </button>
                    </div>
                </>
            ),
        },
    ];
    const confirmDelete = async (id, title) => {
        await helper.sweetalert
            .confirm(`confirm to delete ${title}`, "warning")
            .then(async (result) => {
                if (result.isConfirmed) {
                    setShowLoader(true);
                    await brandModel.destroy(id).then((res) => {
                        reloadbrandData();
                        helper.sweetalert.toast(`${title} deleted Successfully`);
                    });
                    setShowLoader(false);
                }
            });
    };

    return (
        <>
            <Heading title="Diaper-brands" showLoader={isLoading || showLoader}>
                {console.log()}
             <Button className='btn btn-sm float-end' href={'brands/create'}>+ Create</Button>
            </Heading>
            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">diaper brand Lists</div>
                    <div className="table-responsive">
                        <Table columns={columns} data={brandData?.data || []} />
                    </div>
                    <div className="card-footer">
                        <Pagination meta={brandData?.meta} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
